import { OwnerType, TOwnershipStructure } from './types';
import { MarkerType } from 'reactflow';

export const ROOT_OWNER_NODE = 'MainLegal';
export const UNIQUE_PER_PARENT_TYPES = [OwnerType.SHAREHOLDER_GROUP, OwnerType.FREE_FLOAT];
export const MAX_LINK_LEVEL = 20;

export const ownerLabelText = {
  [OwnerType.INDIVIDUAL]: 'Фізична особа',
  [OwnerType.LEGAL_ENTITY]: 'Юридична особа',
  [OwnerType.FREE_FLOAT]: 'Акції у вільному обігу',
  [OwnerType.SHAREHOLDER_GROUP]: 'Група акціонерів',
  [OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP]: 'КБВ незалежно від формального володіння',
};

export const ownerTypeOptions = [
  { label: ownerLabelText[OwnerType.INDIVIDUAL], value: OwnerType.INDIVIDUAL },
  { label: ownerLabelText[OwnerType.LEGAL_ENTITY], value: OwnerType.LEGAL_ENTITY },
  { label: ownerLabelText[OwnerType.FREE_FLOAT], value: OwnerType.FREE_FLOAT },
  { label: ownerLabelText[OwnerType.SHAREHOLDER_GROUP], value: OwnerType.SHAREHOLDER_GROUP },
  {
    label: ownerLabelText[OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP],
    value: OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP,
  },
];

export const entitiesWithSimilarFields = [
  OwnerType.INDIVIDUAL,
  OwnerType.LEGAL_ENTITY,
  OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP,
];

export const individualTypes = [
  OwnerType.INDIVIDUAL,
  OwnerType.BENEFICIARY_WITHOUT_FORMAL_OWNERSHIP,
];

export const forbidenResidencyOprions = [
  { label: 'Резидент РФ', value: '1' },
  { label: 'Резидент РБ', value: '2' },
];

export const forbidenCitizenshipOprions = [
  { label: 'Громадянин РФ', value: '1' },
  { label: 'Громадянин РБ', value: '2' },
];

export const EMPTY_FORBIDEN_COUNTRY_INDIVIDUAL = {
  fullName: null,
  ownershipShare: null,
  residencyStatus: null,
  citizenshipStatus: null,
};

export const EMPTY_FORBIDEN_COUNTRY_LEGAL_ENTITY = {
  entityName: null,
  ownershipShare: null,
  residencyStatus: null,
};

export const EMPTY_RANGE = { number: null, from: null, to: null };
export const MAX_DEPTH_LEVEL = 19;

export const HORIZONTAL = 250;
export const ROOT_NODE_ID = '1';
export const NODE_WIDTH = 190;
export const NODE_HEIGHT = 140;
export const LINE_HEIGHT = 35;
export const BASE_HEIGHT = 40;

export const CONTAINER_WIDTH = 2200;
export const CONTAINER_HEIGHT = 1000;
export const RENDER_RETRY_COUNT = 15;
export const RENDER_RETRY_DELAY_MS = 200;

export const PAGE_WIDTH = 297;
export const PAGE_HEIGHT = 210;
export const PAGE_MARGIN = 1;
export const DIAGRAM_ELEMENTS_MARGIN = 9;
export const LOGO_HEIGHT = 13;
export const LOGO_WIDTH = 20;

export const SPACE_IN_TEXT = '\u00A0\u00A0\u00A0\u00A0';
export const PIXELS_PER_INCH = 96; // пікселі в одному дюймі на моніторі
export const MM_PER_INCH = 25.4; // міліметри в одному дюймі
export const EDGE_ZONE_SIZE = 50;

export const edgeStyle = {
  type: 'smoothstep' as const,
  style: { stroke: '#0166B3FF', strokeWidth: 1.5, fill: 'transparent' },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 30,
    height: 50,
    color: '#004785FF',
  },
};

export const paragraphOne =
  '****Кінцевого бенефіціарного власника (контролера) визначає виключно Клієнт. Банк на підставі структури власності пересвідчується в коректності і повноті наданої інформації.';
export const paragraphTwo =
  "**ВАЖЛИВО!** Володіння однією особою самостійно або спільно з пов'язаними фізичними особами та/або юридичними особами часткою в юридичній особі у розмірі 25 чи більше відсотків статутного капіталу або прав голосу в юридичній особі не є обов'язковою умовою, яка дає змогу визначити належність фізичної особи до кінцевого бенефіціарного власника (контролера).";
export const paragraphThree =
  'В даній структурі зазначений реальний кінцевий бенефіціарний власник.';
export const paragraphFour =
  'Трастові декларації, договори довірчого управління, декларації довірчої власності, афідевіти тощо з іншими особами не укладалися.';
export const paragraphFifth =
  'Надаючи дану структуру власності, підтверджую, що ознайомлений із вимогами статтей 11 та 15 Закону України «Про запобігання та протидію легалізації (відмиванню) доходів, одержаних злочинним шляхом, фінансуванню тероризму та фінансуванню розповсюдження зброї масового знищення».';
export const emptyIndividualText =
  'Ви можете додати фізичну особу, якщо цей власник формально тримає частку в інтересах іншої особи.';
export const emptyLegalText =
  'Власники не додані. Додайте учасника або вкажіть, що засновники/учасники відсутні';
export const sourceTooltip =
  'Вкажіть посилання на джерело, що підтверджує перебування акцій у вільному обігу (біржа, реєстр, сайт емітента тощо). Одна картка — одне джерело. Якщо джерел кілька — додайте окрему картку для кожного. Посилання відображається повністю на картці у схемі.';
export const rangeTooltip = `Спосіб заповнення залежить від розміру частки кожного акціонера та їх кількості.
Заповніть кожного акціонера окремою карткою (як ФО або ЮО), якщо:
• частка акціонера становить 5% і більше — незалежно від кількості таких осіб;
• частка акціонера становить менше 5%, але таких акціонерів не більше 10.
Об'єднайте акціонерів у картку «Група акціонерів», якщо:
• таких акціонерів більше 10 і кожен із них має частку менше 1%, а разом вони володіють менше 5%.`;
export const beneficiaryFormalOwnershipTooltip =
  'Зміни заблоковані, оскільки обрано тип власника “КБВ незалежно від формального володіння” - це фізичні особи, які незалежно від формального володіння мають можливість здійснювати вирішальний вплив на управління або господарську діяльність юридичної особи.';
export const beneficiaryTooltip =
  "Якщо ця особа не є КБВ, ви можете додати до неї іншу фізичну особу — кінцевого бенефіціарного власника (КБВ). У такому разі ця особа автоматично набуває статусу довірчого власника — тобто особи, яка формально володіє часткою, але не є реальним бенефіціаром. Після додавання дочірньої ФО обов'язково вкажіть для неї КБВ = «Так». Без цього збереження буде неможливим.";
export const beneficiaryPercentageTooltip =
  'Для обраного типу “КБВ незалежно від формального володіння” частка завжди дорівнює 0% - особа не є формальним власником. Якщо ця особа все ж володіє часткою у статутному капіталі - необхідно додати окремою каткою обравши тип “Фізична особа” та зазначити відповіду частку володіння.';

export const testDataComplexOwnershipStructure: TOwnershipStructure = {
  ownershipStructureSpecifics: '',
  isFoundersAndBeneficiariesAbsent: false,
  link: [
    {
      ownershipPercentage: 89,
      toNodeId: 'MainLegal',
      fromNodeId: 'f5df2109-a0f5-47d7-ac92-025713c5fe70',
      id: 'ea8b2cc2-133e-4944-9f5b-f5aa92c7c500',
      displayOrder: 1,
      parentLinkId: null,
    },
    {
      ownershipPercentage: 11,
      toNodeId: 'MainLegal',
      fromNodeId: '96a98909-487e-4993-8b4a-9f4ea0022910',
      id: 'c4aec0fa-e02a-45da-bc4d-5941cbc9ab88',
      displayOrder: 2,
      parentLinkId: null,
    },
    {
      ownershipPercentage: 80,
      toNodeId: 'f5df2109-a0f5-47d7-ac92-025713c5fe70',
      fromNodeId: '96a98909-487e-4993-8b4a-9f4ea0022910',
      id: '8c214891-bf28-436a-b56a-46a36af42e78',
      displayOrder: 1,
      parentLinkId: 'ea8b2cc2-133e-4944-9f5b-f5aa92c7c500',
    },
    {
      ownershipPercentage: 45.5,
      toNodeId: '96a98909-487e-4993-8b4a-9f4ea0022910',
      fromNodeId: '7f181cab-b07b-4531-917f-06994233e5f3',
      id: 'c0030cc5-330c-4ca4-a9ca-bf74b27795c9',
      displayOrder: 0,
      parentLinkId: 'c4aec0fa-e02a-45da-bc4d-5941cbc9ab88',
    },
    {
      ownershipPercentage: 54.5,
      toNodeId: '96a98909-487e-4993-8b4a-9f4ea0022910',
      fromNodeId: 'e58b4550-b131-41f9-896a-18e6834b356c',
      id: '6c3deae4-9143-47d5-9f51-9c12dc1fc53a',
      displayOrder: 1,
      parentLinkId: 'c4aec0fa-e02a-45da-bc4d-5941cbc9ab88',
    },
    {
      ownershipPercentage: 20,
      toNodeId: 'f5df2109-a0f5-47d7-ac92-025713c5fe70',
      fromNodeId: '0f995253-32f6-4740-a438-f95fc36f6f73',
      id: 'a4cd5d0f-9cfb-435e-be9f-44ea35b13bcc',
      displayOrder: 2,
      parentLinkId: 'ea8b2cc2-133e-4944-9f5b-f5aa92c7c500',
    },
    {
      ownershipPercentage: 100,
      toNodeId: '0f995253-32f6-4740-a438-f95fc36f6f73',
      fromNodeId: 'afd6388c-2273-4697-95da-5cb71e653169',
      id: 'fdb5de1b-e6e7-4b2b-8068-04579fcda90e',
      displayOrder: 0,
      parentLinkId: 'a4cd5d0f-9cfb-435e-be9f-44ea35b13bcc',
    },
  ],
  ownershipPercentageTotal: '100',
  owners: [
    {
      areIndividualsWithDecisiveInfluenceAbsent: false,
      type: OwnerType.LEGAL_ENTITY,
      hasRussianOrBelarusianCitizenShareholders: null,
      rangeIndividual: null,
      rangeLegal: null,
      russianBelarusianLegalEntities: null,
      russianBelarusianIndividuals: null,
      isOtherTaxResident: false,
      isInBankBlackList: false,
      isUSTaxResident: false,
      sourceURL: null,
      id: 'f5df2109-a0f5-47d7-ac92-025713c5fe70',
      registrationDate: '05.10.2016',
      residenceCountry: { value: '804', label: 'Україна' },
      typesOfActivity: {
        value: '780113',
        label: '01.13 - Вирощування овочів і баштанних культур, коренеплодів і бульбоплодів',
      },
      isInTerList: false,
      isBeneficiary: false,
      address: {
        registrationAddress: {
          address: 'Україна, 03150, М.КИЇВ, вул. Предславинська, 31/11',
          country: { value: '804', label: 'Україна' },
          postalCode: '03150',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Предславинська' },
          houseNumber: '31/11',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 03150, М.КИЇВ, вул. Предславинська, 31/11',
          country: { value: '804', label: 'Україна' },
          postalCode: '03150',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Предславинська' },
          houseNumber: '31/11',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
      birthDate: null,
      documents: {
        documentType: null,
        registryRecord: null,
        documentSeries: null,
        documentNumber: null,
        issueDate: null,
        documentExpiryDate: null,
        issuingAuthority: null,
      },
      birthPlace: '',
      birthplaceCountry: null,
      citizenshipCountry: null,
      foreignTaxNumber: '',
      identificationNumber: '40875123',
      shortNameUkr: 'ТОВ"СЛАВ ГРУПП"',
      fullName: 'ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ "СЛАВ ГРУПП"',
      middleName: null,
      firstName: '',
      lastName: '',
      ownershipPercentage: 89,
      linksLabels: null,
      isRegardlessOfFormalOwnership: false,
    },
    {
      areIndividualsWithDecisiveInfluenceAbsent: false,
      type: OwnerType.LEGAL_ENTITY,
      hasRussianOrBelarusianCitizenShareholders: null,
      rangeIndividual: null,
      rangeLegal: null,
      russianBelarusianLegalEntities: null,
      russianBelarusianIndividuals: null,
      isOtherTaxResident: false,
      isInBankBlackList: false,
      isUSTaxResident: false,
      sourceURL: null,
      id: '96a98909-487e-4993-8b4a-9f4ea0022910',
      registrationDate: '12.11.2012',
      residenceCountry: { value: '804', label: 'Україна' },
      typesOfActivity: { value: '780112', label: '01.12 - Вирощування рису' },
      isInTerList: false,
      isBeneficiary: false,
      address: {
        registrationAddress: {
          address: 'Україна, 01024, М.КИЇВ, м. КИЇВ, вул. Круглоуніверситетська, 14',
          country: { value: '804', label: 'Україна' },
          postalCode: '01024',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Круглоуніверситетська' },
          houseNumber: '14',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 01024, М.КИЇВ, м. КИЇВ, вул. Круглоуніверситетська, 14',
          country: { value: '804', label: 'Україна' },
          postalCode: '01024',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Круглоуніверситетська' },
          houseNumber: '14',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
      birthDate: null,
      documents: {
        documentType: null,
        registryRecord: null,
        documentSeries: null,
        documentNumber: null,
        issueDate: null,
        documentExpiryDate: null,
        issuingAuthority: null,
      },
      birthPlace: '',
      birthplaceCountry: null,
      citizenshipCountry: null,
      foreignTaxNumber: '',
      identificationNumber: '38408438',
      shortNameUkr: 'ГРАТІС',
      fullName:
        'ПУБЛІЧНЕ АКЦІОНЕРНЕ ТОВАРИСТВО "ЗАКРИТИЙ НЕДИВЕРСИФІКОВАНИЙ ВЕНЧУРНИЙ КОРПОРАТИВНИЙ ІНВЕСТИЦІЙНИЙ ФОНД "ГРАТІС',
      middleName: null,
      firstName: '',
      lastName: '',
      ownershipPercentage: 11,
      linksLabels: null,
      isRegardlessOfFormalOwnership: false,
    },
    {
      id: 'e58b4550-b131-41f9-896a-18e6834b356c',
      lastName: 'Бондаренко',
      firstName: 'Юлія',
      middleName: 'Едуардівна',
      ownershipPercentage: 54.5,
      identificationNumber: '3518501642',
      foreignTaxNumber: '',
      citizenshipCountry: { value: '804', label: 'Україна' },
      residenceCountry: { value: '804', label: 'Україна' },
      birthplaceCountry: { value: '804', label: 'Україна' },
      birthPlace: 'М.ДОНЕЦЬК',
      documents: {
        documentType: { value: '1', label: 'Паспорт громадянина України' },
        registryRecord: null,
        documentSeries: 'ВК',
        documentNumber: '915693',
        issueDate: '19.06.2012',
        documentExpiryDate: '01.05.2041',
        issuingAuthority: 'КИЇВСЬКИМ РВ ДМУ ГУМВС УКРАЇНИ В ДОНЕЦЬКІЙ ОБЛ.',
      },
      birthDate: '01.05.1996',
      address: {
        registrationAddress: {
          address: 'Україна, 01014, М.КИЇВ, м. КИЇВ, вул. Буслівська, 12, 44',
          country: { value: '804', label: 'Україна' },
          postalCode: '01014',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Буслівська' },
          houseNumber: '12',
          building: null,
          apartment: '44',
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 01014, М.КИЇВ, м. КИЇВ, вул. Буслівська, 12, 44',
          country: { value: '804', label: 'Україна' },
          postalCode: '01014',
          region: { value: '26', label: 'М.КИЇВ' },
          district: { value: '', label: '' },
          city: { value: '191919', label: 'м. КИЇВ' },
          street: { value: 'вул.', label: 'вул. Буслівська' },
          houseNumber: '12',
          building: null,
          apartment: '44',
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
      isUSTaxResident: false,
      isOtherTaxResident: false,
      isInTerList: false,
      isInBankBlackList: false,
      isBeneficiary: true,
      type: OwnerType.INDIVIDUAL,
      linksLabels: null,
      fullName: null,
      shortNameUkr: null,
      rangeLegal: null,
      rangeIndividual: null,
      sourceURL: null,
      registrationDate: null,
      typesOfActivity: null,
      russianBelarusianIndividuals: null,
      russianBelarusianLegalEntities: null,
      hasRussianOrBelarusianCitizenShareholders: null,
      isRegardlessOfFormalOwnership: false,
      areIndividualsWithDecisiveInfluenceAbsent: false,
    },
    {
      id: '7f181cab-b07b-4531-917f-06994233e5f3',
      lastName: 'БОНДАРЕНКО',
      firstName: 'ІГОР',
      middleName: 'ЕДУАРДОВИЧ',
      ownershipPercentage: 45.5,
      identificationNumber: '3654300871',
      foreignTaxNumber: '',
      citizenshipCountry: { value: '804', label: 'Україна' },
      residenceCountry: { value: '804', label: 'Україна' },
      birthplaceCountry: { value: '804', label: 'Україна' },
      birthPlace: 'М.КАМІНЬ-РИБОЛОВ ХАНКАЙСЬКИЙ Р-Н ПРИМОРСЬКИЙ КРАЙ',
      documents: {
        documentType: { value: '1', label: 'Паспорт громадянина України' },
        registryRecord: null,
        documentSeries: 'ВК',
        documentNumber: '563840',
        issueDate: '25.11.2008',
        documentExpiryDate: null,
        issuingAuthority: 'КИЇВСЬКИМ РВ ДМУ ГУ МВС УКРАЇНИ В ДОНЕЦЬКІЙ ОБЛАСТІ',
      },
      birthDate: '29.06.1971',
      address: {
        registrationAddress: {
          address:
            'Україна, 14002, Волинська область, Ковельський район, м. Горохів, вул. Бориса Климчука, 16',
          country: { value: '804', label: 'Україна' },
          postalCode: '14002',
          region: { value: '3', label: 'Волинська область' },
          district: { value: '6', label: 'Ковельський район' },
          city: { value: '153703', label: 'м. Горохів' },
          street: { value: '13422', label: 'вул. Бориса Климчука' },
          houseNumber: '16',
          building: null,
          apartment: null,
          codeAddress: null,
        },
        permanentAddress: {
          address:
            'Україна, 14002, Волинська область, Ковельський район, м. Горохів, вул. Бориса Климчука, 16',
          country: { value: '804', label: 'Україна' },
          postalCode: '14002',
          region: { value: '3', label: 'Волинська область' },
          district: { value: '6', label: 'Ковельський район' },
          city: { value: '153703', label: 'м. Горохів' },
          street: { value: '13422', label: 'вул. Бориса Климчука' },
          houseNumber: '16',
          building: null,
          apartment: null,
          codeAddress: null,
        },
        coincidences: true,
      },
      isUSTaxResident: false,
      isOtherTaxResident: false,
      isInTerList: false,
      isInBankBlackList: false,
      isBeneficiary: true,
      type: OwnerType.INDIVIDUAL,
      linksLabels: null,
      fullName: null,
      shortNameUkr: null,
      rangeLegal: null,
      rangeIndividual: null,
      sourceURL: null,
      registrationDate: null,
      typesOfActivity: null,
      russianBelarusianIndividuals: null,
      russianBelarusianLegalEntities: null,
      hasRussianOrBelarusianCitizenShareholders: null,
      isRegardlessOfFormalOwnership: false,
      areIndividualsWithDecisiveInfluenceAbsent: false,
    },
    {
      areIndividualsWithDecisiveInfluenceAbsent: false,
      type: OwnerType.LEGAL_ENTITY,
      hasRussianOrBelarusianCitizenShareholders: null,
      rangeIndividual: null,
      rangeLegal: null,
      russianBelarusianLegalEntities: null,
      russianBelarusianIndividuals: null,
      isOtherTaxResident: false,
      isInBankBlackList: false,
      isUSTaxResident: false,
      sourceURL: null,
      id: '0f995253-32f6-4740-a438-f95fc36f6f73',
      registrationDate: null,
      residenceCountry: { value: '804', label: 'Україна' },
      typesOfActivity: null,
      isInTerList: false,
      isBeneficiary: null,
      address: {
        registrationAddress: {
          address: 'Україна',
          country: { value: '804', label: 'Україна' },
          postalCode: null,
          region: { value: '', label: '' },
          district: { value: '', label: '' },
          city: { value: '', label: '' },
          street: { value: '', label: '' },
          houseNumber: null,
          building: null,
          apartment: null,
          codeAddress: null,
        },
        permanentAddress: {
          address: 'Україна',
          country: { value: '804', label: 'Україна' },
          postalCode: null,
          region: { value: '', label: '' },
          district: { value: '', label: '' },
          city: { value: '', label: '' },
          street: { value: '', label: '' },
          houseNumber: null,
          building: null,
          apartment: null,
          codeAddress: null,
        },
        coincidences: false,
      },
      birthDate: null,
      documents: {
        documentType: null,
        registryRecord: null,
        documentSeries: null,
        documentNumber: null,
        issueDate: null,
        documentExpiryDate: null,
        issuingAuthority: null,
      },
      birthPlace: '',
      birthplaceCountry: null,
      citizenshipCountry: null,
      foreignTaxNumber: '',
      identificationNumber: '41813356',
      shortNameUkr: 'ТОВ "ІНВЕСТ КАПІТАЛ СХІД"',
      fullName: 'ТОВ "ІНВЕСТ КАПІТАЛ СХІД"',
      middleName: null,
      firstName: '',
      lastName: '',
      ownershipPercentage: 20,
      linksLabels: null,
      isRegardlessOfFormalOwnership: false,
    },
    {
      id: 'afd6388c-2273-4697-95da-5cb71e653169',
      lastName: 'Бєлік',
      firstName: 'ооо',
      middleName: 'ппп',
      ownershipPercentage: 100,
      identificationNumber: '2812509840',
      foreignTaxNumber: '',
      citizenshipCountry: { value: '804', label: 'Україна' },
      residenceCountry: { value: '804', label: 'Україна' },
      birthplaceCountry: { value: '804', label: 'Україна' },
      birthPlace: '',
      documents: {
        documentType: null,
        registryRecord: null,
        documentSeries: null,
        documentNumber: null,
        issueDate: null,
        documentExpiryDate: null,
        issuingAuthority: null,
      },
      birthDate: '01.01.2003',
      address: {
        registrationAddress: {
          address: 'Україна',
          country: { value: '804', label: 'Україна' },
          postalCode: null,
          region: { value: '', label: '' },
          district: { value: '', label: '' },
          city: { value: '', label: '' },
          street: { value: '', label: '' },
          houseNumber: null,
          building: null,
          apartment: null,
          codeAddress: null,
        },
        permanentAddress: {
          address: 'Україна',
          country: { value: '804', label: 'Україна' },
          postalCode: null,
          region: { value: '', label: '' },
          district: { value: '', label: '' },
          city: { value: '', label: '' },
          street: { value: '', label: '' },
          houseNumber: null,
          building: null,
          apartment: null,
          codeAddress: null,
        },
        coincidences: false,
      },
      isUSTaxResident: false,
      isOtherTaxResident: false,
      isInTerList: false,
      isInBankBlackList: false,
      isBeneficiary: false,
      type: OwnerType.INDIVIDUAL,
      linksLabels: null,
      fullName: null,
      shortNameUkr: null,
      rangeLegal: null,
      rangeIndividual: null,
      sourceURL: null,
      registrationDate: null,
      typesOfActivity: null,
      russianBelarusianIndividuals: null,
      russianBelarusianLegalEntities: null,
      hasRussianOrBelarusianCitizenShareholders: null,
      isRegardlessOfFormalOwnership: false,
      areIndividualsWithDecisiveInfluenceAbsent: false,
    },
  ],
};
